/**
 * Bulk Selection Summary
 *
 * Exibe a soma das linhas selecionadas nas listagens financeiras com seleção
 * em lote (receitas e despesas). Mostra dois totais empilhados: o planejado em
 * cima e o realizado embaixo.
 */
import { CurrencyDisplay } from './CurrencyDisplay';

interface BulkSelectionSummaryProps {
  /** Rótulo do total superior (ex.: "Planejado", "Objetivo"). */
  plannedLabel: string;
  /** Soma do valor planejado das linhas selecionadas. */
  plannedTotal: number;
  /** Rótulo do total intermediário (ex.: "Realizado", "Acumulado"). */
  realizedLabel: string;
  /** Soma do valor realizado das linhas selecionadas. */
  realizedTotal: number;
}

export function BulkSelectionSummary({
  plannedLabel,
  plannedTotal,
  realizedLabel,
  realizedTotal,
}: Readonly<BulkSelectionSummaryProps>) {
  return (
    <div
      className="flex flex-col items-start gap-0.5 text-sm leading-tight sm:items-end"
      aria-live="polite"
    >
      <div className="flex items-center gap-1.5">
        <span className="text-xs text-muted-foreground">{plannedLabel}:</span>
        <CurrencyDisplay value={plannedTotal} size="sm" className="font-semibold" />
      </div>
      <div className="flex items-center gap-1.5">
        <span className="text-xs text-muted-foreground">{realizedLabel}:</span>
        <CurrencyDisplay value={realizedTotal} size="sm" className="font-semibold" />
      </div>
    </div>
  );
}

export default BulkSelectionSummary;
